// extracted by mini-css-extract-plugin
export default {"toaster":"useToaster--toaster--THY8t"};